import { ReactNode } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import OmiFloatingButton from "./OmiFloatingButton";

interface LayoutProps {
  children: ReactNode;
  showNavigation?: boolean;
  showFooter?: boolean;
}

const Layout = ({ children, showNavigation = true, showFooter = true }: LayoutProps) => {
  return (
    <>
      {showNavigation && <Navigation />}
      {children}
      {showFooter && <Footer />}
      <OmiFloatingButton />
    </>
  );
};

export default Layout;
